import { installedModules } from "@/modules/registry.generated";
import { FallbackModuleHeaderAction } from "./ModuleHeaderAction";

export function ModuleSiteComponents(props: { enabledModules: string[]; locale: string }) {
  const enabled = new Set(props.enabledModules);
  return installedModules
    .filter((module) => enabled.has(module.id) && Object.keys(module.dependencies).every((dependency) => enabled.has(dependency)) && module.capabilities.includes("site") && module.siteComponent)
    .map((module) => {
      const Component = module.siteComponent!;
      return <Component key={module.id} locale={props.locale} headerProvided={!!module.headerComponent} />;
    });
}

/** Standard header placement; theme code never has to move module DOM nodes. */
export function ModuleHeaderActions(props: { enabledModules: string[]; locale: string }) {
  const enabled = new Set(props.enabledModules);
  const modules = installedModules.filter((module) => enabled.has(module.id) && module.capabilities.includes("site")
    && Object.keys(module.dependencies).every((dependency) => enabled.has(dependency)) && module.headerComponent);
  if (!modules.length) return null;
  const label = { nl: "Winkelacties", en: "Store actions", de: "Shop-Aktionen", fr: "Actions de la boutique" }[props.locale] ?? "Store actions";
  return <nav className="cms-module-header-actions" aria-label={label}>{modules.map((module) => {
    const Component = module.headerComponent!;
    return <FallbackModuleHeaderAction key={module.id} moduleId={module.id}><Component locale={props.locale} /></FallbackModuleHeaderAction>;
  })}</nav>;
}
